module.exports = __webpack_public_path__ + "img/menuc08.b9a3bcc3.png";